import {
    Component,
    HostListener,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { CdnService } from '@/common/cdn/cdn.service';
import Swiper from 'swiper';
import { GetConfigParamsUseCase } from '@/core/domain/configurations/usecases/getConfigParams-loader.usecase';
import {
    CardRoutes,
    FeatureFlags,
} from '@/core/domain/configurations/models/configurations.model';
import { SetDataLayerParamsUseCase } from '@/core/domain/gtm/usecases/setDataLayer.usecase';
import { GtmPageView } from '@/core/domain/gtm/models/gtm-page-view.models';
import { Router } from '@angular/router';
import { GtmLandingDashboard } from '@/core/domain/gtm/models/gtm-landig-dashboard.models';
import { DeletePurchaseUseCase } from '@/core/domain/purchase-persistence/usecases/delete-purchase-persistence.usecase ';
import { UrlService } from '@/common/url/url.service';
import { environment as env } from '@/env/environment';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'vg-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class HomeComponent implements OnInit {
    maintenance = false;
    purchaseEnabled = true;
    redemptionEnabled = true;
    isMobileResolution!: boolean;
    VIVA_GIFT_LP = 'ev_viva_gift_lp';

    public unsubscribeSignal: Subject<void> = new Subject();

    constructor(
        private readonly getFeatureFlags: GetConfigParamsUseCase<FeatureFlags>,
        private readonly gtmDataLayer: SetDataLayerParamsUseCase,
        private readonly deletePurchasePersistence: DeletePurchaseUseCase,
        private readonly getCardRoutesConfig: GetConfigParamsUseCase<
            CardRoutes[]
        >,
        private readonly router: Router,
        private readonly url: UrlService,
    ) {
        this.initFeatureFlags();
        this.onResize();
    }

    private initFeatureFlags(): void {
        this.getFeatureFlags.execute('featureFlags').subscribe((data) => {
            this.maintenance = data.maintenance;
            this.purchaseEnabled = data.purchaseEnabled;
            this.redemptionEnabled = data.redemptionEnabled;
        });
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.isMobileResolution =
            window.matchMedia('(max-width: 768px)').matches;
    }

    getBackgroundImageUrl(): string {
        return this.isMobileResolution
            ? `${env.cdn}/vg/landing/home/banner_mobile.png`
            : `${env.cdn}/vg/landing/home/banner_desktop.png`;
    }

    titlePage = 'Cómo canjear tu Viva Gift';
    subTitle = 'Cómo canjear tu Viva Gift';
    page = 'dashboard';
    dataTest = [
        {
            title: 'vg_landing_home_gift-step-info-create-title',
            image: CdnService.url('vg/landing/home/btc_step_1.svg'),
            text: 'vg_landing_home_gift-step-info-create-text',
        },
        {
            title: 'vg_landing_home_gift-step-info-send-title',
            image: CdnService.url('vg/landing/home/btc_step_2.svg'),
            text: 'vg_landing_home_gift-step-info-send-text',
        },
        {
            title: 'vg_landing_home_gift-step-info-give-title',
            image: CdnService.url('vg/landing/home/btc_step_3.svg'),
            text: 'vg_landing_home_gift-step-info-give-text',
        },
    ];

    dataTest_2 = [
        {
            title: 'vg_landing_home_gift-business-info-1-title',
            image: CdnService.url('vg/landing/home/btb_step_1.svg'),
            text: 'vg_landing_home_gift-business-info-1-text',
        },
        {
            title: 'vg_landing_home_gift-business-info-2-title',
            image: CdnService.url('vg/landing/home/btb_step_2.svg'),
            text: 'vg_landing_home_gift-business-info-2-text',
        },
        {
            title: 'vg_landing_home_gift-business-info-3-title',
            image: CdnService.url('vg/landing/home/btb_step_3.svg'),
            text: 'vg_landing_home_gift-business-info-3-text',
        },
    ];

    public routes: CardRoutes[] = [];

    faqs = [
        {
            title: 'vg_landing_home_gift-faq-question-1',
            info: 'vg_landing_home_gift-faq-answer-1',
        },
        {
            title: 'vg_landing_home_gift-faq-question-2',
            info: 'vg_landing_home_gift-faq-answer-2',
        },
        {
            title: 'vg_landing_home_gift-faq-question-3',
            info: 'vg_landing_home_gift-faq-answer-3',
        },
        {
            title: 'vg_landing_home_gift-faq-question-4',
            info: 'vg_landing_home_gift-faq-answer-4',
        },
        {
            title: 'vg_landing_home_gift-faq-question-5',
            info: 'vg_landing_home_gift-faq-answer-5',
        },
        {
            title: 'vg_landing_home_gift-faq-question-6',
            info: 'vg_landing_home_gift-faq-answer-6',
        },
        {
            title: 'vg_landing_home_gift-faq-question-7',
            info: 'vg_landing_home_gift-faq-answer-7',
        },
        {
            title: 'vg_landing_home_gift-faq-question-8',
            info: 'vg_landing_home_gift-faq-answer-8',
        },
    ];

    headerGtm = ['click_give_giftcard', 'click_redeem_giftcard'];
    sliderGtm = ['click_arrow_right', 'click_arrow_left'];

    public routesForSwiper: CardRoutes[] = [];

    ngOnInit() {
        this.initCardRoutesConfig();
        this.gtmPageView();
    }

    public identifyRoutes(index: number): number {
        return index;
    }

    private initCardRoutesConfig(): void {
        this.getCardRoutesConfig.execute('routes').subscribe({
            next: (response: CardRoutes[]) =>
                this.onGetCardRoutesConfig(response),
            error: (error) => {
                //TODO agregar caso de error
            },
        });
    }

    private onGetCardRoutesConfig(cardRoutes: CardRoutes[]): void {
        this.routes = cardRoutes;
        this.initSwiper();
    }

    initSwiper() {
        this.routesForSwiper = this.routes.concat(this.routes);
        new Swiper('.swiper-routes', {
            direction: 'horizontal',
            loop: true,
            spaceBetween: '27px',
            breakpoints: {
                1: {
                    slidesPerView: 1.2,
                },
                759: {
                    slidesPerView: 2,
                },
                991: {
                    slidesPerView: 2.5,
                },
            },
        });
    }

    gtmPageView() {
        this.gtmDataLayer.execute<GtmPageView>({
            event: 'ev_pageview',
            page_path: this.router.url,
            page_title: 'Landing',
        });
    }
    gtmActionHeader(action: number) {
        this.gtmDataLayer.execute<GtmLandingDashboard>({
            event: this.VIVA_GIFT_LP,
            category: 'viva_gift_header',
            action: this.headerGtm[action],
        });
    }
    gtmActionSlider(action: number) {
        this.gtmDataLayer.execute<GtmLandingDashboard>({
            event: this.VIVA_GIFT_LP,
            category: 'viva_gift_slider',
            action: this.headerGtm[action],
        });
    }
    onClickGiveGiftCard() {
        this.gtmActionHeader(0);
        this.goToPurchase();
    }

    onClickReedemGiftCard() {
        this.gtmActionHeader(1);
    }

    public goToPurchase(): void {
        this.deletePurchasePersistence.execute().subscribe();
        this.url
            .format('purchase/design')
            .pipe(takeUntil(this.unsubscribeSignal))
            .subscribe((url) => {
                this.unsubscribeSignal.next();
                this.unsubscribeSignal.unsubscribe();
                this.router.navigateByUrl(url);
            });
    }

    onIntersection({ target }: { target: any }) {
        const itemsRoutes: any[] = [];

        this.routes.forEach((item, index) => {
            itemsRoutes.push({
                item_name:
                    'Flight ticket|' +
                    item.nameFromIATA +
                    '-' +
                    item.nameToIATA,
                item_id: item.nameFromIATA + '-' + item.nameToIATA,
                price: item.amount,
                item_brand: 'VB',
                item_category: 'Flight ticket',
                item_category2: item.nameFromIATA + '-' + item.nameToIATA,
                item_category3: item.type,
                promotion_id:
                    'viva_gift_' + item.nameFromIATA + '_' + item.nameToIATA,
                promotion_name: 'destinations_viva_gift',
                creative_name: item.nameFrom,
                creative_slot: '' + (index + 1),
                location_id: 'hero_banner',
                index: index + 1,
                quantity: 1,
            });
        });

        this.gtmDataLayer.execute({
            event: 'view_promotion',
            ecommerce: {
                items: itemsRoutes,
            },
        });
    }
}
